import {SavedSearch} from '../../../../../types';

export const mapSearches = (searches: SavedSearch[] = []) => {
    return searches.filter(s => s.isSaved);
};
